import { Badge, mergeClasses, Text } from '@fluentui/react-components';
import { ProgramParticipantStatus } from 'src/models/rewards/Rewards';
import { formatProgramStatusVisibleDate } from 'src/utils/utils';
import { ERROR_MESSAGES } from 'src/utils/constants';
import { AvailabilityState, AvailabilityFlair } from 'src/utils/enums';
import { memo } from 'react';
import { useStyles } from './RewardProgramStatusDate.styles';

interface Props {
  programParticipantStatus: ProgramParticipantStatus
  customClassName?: string
}

export const RewardProgramStatusDate: React.FC<Props> = ({ programParticipantStatus, customClassName }) => {
  const classes = useStyles();
  const { state, flair } = programParticipantStatus?.programTypeStatus || {};
  const formattedDate = formatProgramStatusVisibleDate(programParticipantStatus);

  const getStatusLabel = (): { label: string, isBadge: boolean } => {
    switch (state) {
      case AvailabilityState.NotAvailableYet:
        return { label: 'Available ', isBadge: true };
      case AvailabilityState.Available:
        return { label: flair === AvailabilityFlair.ExpiringSoon ? 'Available ' : 'Expires ', isBadge: flair === AvailabilityFlair.ExpiringSoon };
      case AvailabilityState.Completed:
        return { label: 'Completed on ', isBadge: false };
      case AvailabilityState.Expired:
        return { label: 'Expired on ', isBadge: false };
      default:
        throw new Error(ERROR_MESSAGES.invalidAvailabilityState(state));
    }
  };

  const { label, isBadge } = getStatusLabel();

  const dateLabel = (
    <Text className={mergeClasses(classes.dateText, customClassName)}>
      {label}
      {formattedDate}
    </Text>
  );

  return isBadge
    ? (
      <Badge appearance="filled" color="success" size="large" data-testid="program-status-date-badge">
        {dateLabel}
      </Badge>
    )
    : (
      dateLabel
    );
};

export default memo(RewardProgramStatusDate);
